// You can pass some outer data here
import _ from 'lodash';
import { request } from 'beans-admin-plugin';

export default () => {
  return [
    {
      prop: 'id',
      label: '编号',
      width: 80
    },
    {
      prop: 'goods_id',
      label: '商品ID',
      width: 300,
      form: {
        component: 'select',
        props: {
          clearable: true,
          hint: '请输入sku_id进行搜索',
          xRemotePreload: async () => {
            const { data } = await request.get('/goodses', { params: { per_page: 999 } })
            return _.map(data, goods => ({ value: goods.id, label: goods.display_name }))
          },
          xRemoteSearch: async (keyword) => {
            const { data } = await request.get('/goodses', { params: { sku_id_cont: keyword } })
            return _.map(data, goods => ({ value: goods.id, label: goods.display_name }))
          }
        }
      },
      renderCell(h, { row }) {
        const goods = _.get(row, 'goods', {})
        return (
          <div class="flex item-center">
            {
              goods && (
                <c-router-link to={{ name: 'products.goods_list', params: { id: goods.product_id } }}>
                  <el-button type="text">{goods.display_name}</el-button>
                </c-router-link>)
            }
          </div>
        )
      }
    },
    {
      prop: 'sku_id',
      label: '商品sku_id',
      width: 100,
      renderCell(h, { row }) {
        const goods = _.get(row, 'goods', {})
        return (
          <div class="flex item-center">
            {
              goods && (<span>{ goods.sku_id }</span>)
            }
          </div>
        )
      },
    },
    {
      prop: 'quantity_threshold',
      label: '下单数量',
      form: {
        component: 'input',
        required: true,
        props: {
          type: 'number'
        }
      }
    },
    {
      prop: 'price_per_unit',
      label: '单价(元)',
      form: {
        component: 'input',
        required: true,
        props: {
          type: 'number'
        }
      }
    },
    {
      prop: 'updated_at',
      label: '创建时间',
      renderCell: 'time',
      width: 120,
    },
    {
      prop: 'created_at',
      label: '更新时间',
      action: ['hide-in-table'],
      renderCell: 'time',
      sort: 'order_by'
    }
  ];
}
